export default "__VITE_ASSET__BLcZWy2k__"